var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:({height:_vm.height+'px',backgroundColor: _vm.bg_color})})])
}
var staticRenderFns = []

export { render, staticRenderFns }